<template>
	<div class="ui dropdown item" v-if="activeMerchant" @click="fetchMerchants">
    <span class="active-merchant-name">{{ activeMerchant.name }}</span>
    <i class="dropdown icon" v-if="merchants.length > 1"/>
		<div class="menu" v-if="merchants.length > 1">
			<a @click="switchMerchant(merchant.id)" v-for="merchant in merchants" :key="merchant.id" class="item" :class="{ 'active' : merchant.id == activeMerchant.id }">
				{{ merchant.name }}
			</a>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'MerchantMenu',

		mounted () {
			$(this.$el).dropdown()
		},

		methods: {
			switchMerchant (id) {
				this.$parent.fetchActiveMerchant(id)
			},

			fetchMerchants () {
				this.$parent.fetchMerchants()
					.then(merchants => {
						if (merchants.data.length > 1) {
							$(this.$el).dropdown('refresh')
						}
					})
			}
		},

		computed: {
			activeMerchant () {
				return this.$store.getters.activeMerchant
			},

			merchants () {
				return this.$store.getters.Merchants ? this.$store.getters.Merchants.data : []
			}
		}
	}
</script>

<style lang="scss">
.active-merchant-name {
  @media screen and (max-width: 767px){
    max-width: 92%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/layout/MerchantMenu.vue